export const CV_RERUN_PROJECT_ID_KEY = 'cv_rerun_project_id';
export const CV_RERUN_ACTIVE_KEY = 'cv_rerun_active';

export function parsePositiveProjectId(value) {
  if (value == null || value === '') {
    return null;
  }
  const id = Number(value);
  if (!Number.isInteger(id) || id <= 0) {
    return null;
  }
  return id;
}

export function readRerunProjectIdFromSession() {
  if (typeof sessionStorage === 'undefined') {
    return null;
  }
  const raw = sessionStorage.getItem(CV_RERUN_PROJECT_ID_KEY);
  if (raw == null || raw === '') {
    return null;
  }
  return parsePositiveProjectId(raw);
}

export function writeRerunProjectIdToSession(projectId) {
  const id = parsePositiveProjectId(projectId);
  if (id == null || typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(CV_RERUN_PROJECT_ID_KEY, String(id));
  sessionStorage.setItem(CV_RERUN_ACTIVE_KEY, '1');
}

export function readRerunActiveFromSession() {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(CV_RERUN_ACTIVE_KEY) === '1';
}

export function clearRerunProjectIdSession() {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(CV_RERUN_PROJECT_ID_KEY);
  sessionStorage.removeItem(CV_RERUN_ACTIVE_KEY);
}

/**
 * Rerun is active when any of: store flag (Result → Menu), ?rerun=1, or session
 * written by conceptValuationMarkRerunFromResult.
 */
export function isConceptValuationRerunActive(state, routeQuery) {
  return Boolean(
    state.isRerunFromResult
    || (routeQuery && String(routeQuery.rerun) === '1')
    || readRerunActiveFromSession()
  );
}

export function resolveExistingProjectId(state) {
  const fromStore = parsePositiveProjectId(state.projectId);
  if (fromStore != null) {
    return fromStore;
  }
  const fromDetail = state.detail && state.detail.project && state.detail.project.id;
  return parsePositiveProjectId(fromDetail);
}

export function resolveReuseProjectId(state, routeQuery) {
  if (!isConceptValuationRerunActive(state, routeQuery)) {
    return null;
  }
  const fromState = resolveExistingProjectId(state);
  if (fromState != null) {
    return fromState;
  }
  return readRerunProjectIdFromSession();
}
